import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authApi } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]     = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) { setLoading(false); return; }
    try {
      const res = await authApi.getProfile();
      setUser(res.data);
    } catch {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userType');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = (data, userType) => {
    const { accessToken, refreshToken, customer, employee } = data;
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('userType', userType);
    setUser(customer || employee);
  };

  const logout = async () => {
    const rt = localStorage.getItem('refreshToken');
    try { await authApi.logout({ refreshToken: rt }); } catch {}
    localStorage.clear();
    setUser(null);
  };

  const isAdmin       = user?.role === 'ADMIN';
  const isManagement  = ['ADMIN', 'MANAGEMENT'].includes(user?.role);
  const isFinance     = ['ADMIN', 'FINANCE'].includes(user?.role);
  const isHR          = ['ADMIN', 'HR'].includes(user?.role);
  const isCS          = ['ADMIN', 'CS'].includes(user?.role);
  const isOps         = ['ADMIN', 'STAFF'].includes(user?.role);
  const isRider       = user?.role === 'RIDER';
  const isCustomer    = ['B2C', 'B2B'].includes(user?.role) || user?.customer_id;
  const userType      = localStorage.getItem('userType') || 'customer';

  return (
    <AuthContext.Provider value={{
      user, loading, login, logout, loadUser,
      isAdmin, isManagement, isFinance, isHR, isCS, isOps, isRider, isCustomer, userType
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
